import { useState } from "react";
import { Card, CardBody, UncontrolledTooltip } from "reactstrap";
import { connect } from "react-redux";

import {
  age,
  market,
  price,
  product_category,
  style,
  size,
  target_group,
  populateArray,
  eco_friendly,
  brand_rating_options,
  price_point,
  populateArray2,
  brand_awareness_options,
  ecom_rating_options,
  pos_rating_options,
  market_diversity_options,
  retailer_awareness_options,
} from "../../../../static/brands_wholesalers_data";
import EditBrandModal from "../../EditBrandModal";
import ProfileDetailItem from "./ProfileDetailItem";
import ProfileDetailsMultiGenderItem from "./ProfileDetailsMultiGenderItem";
import { useParams } from "react-router-dom";
import { Copy, Minus, Plus } from "react-feather";

import { ReactComponent as DocIcon } from "../../../../assets/doc.svg";
import { ReactComponent as SocialIcon } from "../../../../assets/social.svg";
import { ReactComponent as AgentIcon } from "../../../../assets/agent.svg";
import TLWHITE from "../../../../static/take-look-white.png";

const ProfileDetailsSection = ({ brand }) => {
  const { type } = useParams();
  const [showAllModal, setShowAllModal] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const mainAge = brand?.age?.length ? brand?.main_age : null;
  const mainCategory = brand?.product_category?.length ? brand?.main_category : null;
  const mainStyle = brand?.style?.length ? brand?.main_style : null;
  const mainTargetGroup = brand?.target_group?.length ? brand?.main_target_group : null;

  const sortedTargetGroup = [...(brand.target_group || [])].sort((a, b) => {
    const aIsMen = a?.toLowerCase() === "men";
    const bIsMen = b?.toLowerCase() === "men";
    return aIsMen === bIsMen ? 0 : aIsMen ? -1 : 1;
  });

  const _brandAge = brand?.age?.length
    ? brand?.age
    : brand?.main_age
      ? [brand?.main_age]
      : [];
  const _brandStyle = brand?.style?.length
    ? brand?.style
    : brand?.main_style
      ? [brand?.main_style]
      : [];
  const _brandTargetGroup = sortedTargetGroup?.length
    ? sortedTargetGroup
    : brand?.main_target_group
      ? [brand?.main_target_group]
      : [];
  const _brandCategory = brand?.product_category?.length
    ? brand?.product_category
    : brand?.main_category
      ? [brand?.main_category]
      : [];

  const brandAge = populateArray(_brandAge, age).filter(item => item && item.label && item.label !== "N/A");
  const mainAgePopulated = mainAge ? populateArray([mainAge], age).filter(item => item && item.label && item.label !== "N/A") : [];
  const brandStyle = populateArray(_brandStyle, style).filter(item => item && item.label && item.label !== "N/A");
  const mainBrandStyle = mainStyle ? populateArray([mainStyle], style).filter(item => item && item.label && item.label !== "N/A") : [];

  const brandCategory = populateArray(_brandCategory, product_category).filter(item => item && item.label && item.label !== "N/A");
  const brandTarget = populateArray(_brandTargetGroup, target_group).filter(item => item && item.label && item.label !== "N/A");
  const brandLocation = populateArray(
    brand?.country
      ? [brand?.country]
      : [],
    market
  ).filter(item => item && item.label && item.label !== "N/A");
  const brandMarketOfInterest = populateArray(brand?.market_of_interest, market);
  const brandPrice = populateArray(brand?.price, price).filter(item => item && item.label && item.label !== "N/A");
  const brandPricePoint = populateArray([brand?.price_point || ""], price_point).filter(item => item && item.label && item.label !== "N/A");
  const brandEcoFriendly = populateArray(
    [brand?.eco_friendly || ""],
    eco_friendly
  ).filter(item => item && item.label && item.label !== "N/A");

  const brandRating = populateArray2(
    [Math.round(brand?.brand_rating).toFixed() || ""],
    brand_rating_options,
    "value"
  ).filter(item => item && item.label && item.label !== "N/A");

  const brandRatingUpgrade = populateArray2(
    [Math.round(brand?.brand_rating_upgrade).toFixed() || ""],
    brand_rating_options,
    "value"
  ).filter(item => item && item.label && item.label !== "N/A");

  const retailerAwarenessRating = populateArray2(
    [Math.round(brand?.retailer_awareness).toFixed() || ""],
    retailer_awareness_options,
    "value"
  ).filter(item => item && item.label && item.label !== "N/A");

  const brandAwareness = populateArray2(
    [Math.round(brand?.brand_awareness).toFixed() || ""],
    brand_awareness_options,
    "value"
  ).filter(item => item && item.label && item.label !== "N/A");

  const ecomRating = populateArray2(
    [Math.round(brand?.ecom_rating).toFixed() || ""],
    ecom_rating_options,
    "value"
  ).filter(item => item && item.label && item.label !== "N/A");

  const posRating = populateArray2(
    [Math.round(brand?.pos_rating).toFixed() || ""],
    pos_rating_options,
    "value"
  ).filter(item => item && item.label && item.label !== "N/A");

  const marketDiversity = populateArray2(
    [Math.round(brand?.market_diversity).toFixed() || ""],
    market_diversity_options,
    "value"
  ).filter(item => item && item.label && item.label !== "N/A");

  const brandSize = populateArray([brand?.size || ""], size).filter(item => item && item.label && item.label !== "N/A");
  const totalLook = brand?.total_look
    ? [
      {
        id: 0,
        imageBlack: TLWHITE,
        imageWhite: TLWHITE,
        label: "Total Look",
      },
    ]
    : [];

  const _toggleShowAllModal = () => setShowAllModal((prev) => !prev);
  const isProfileIncomplete = [
    brandLocation,
    brandAge,
    brandStyle,
    brandCategory,
    brandTarget,
    brandPrice,
    ...(type !== "retailer" ? [brandEcoFriendly, brandSize] : []),
  ]?.some(
    (arr) => Array.isArray(arr) && arr.some((item) => item?.label === "N/A")
  );

  return (
    <Card className="shadow-sm my-3">
      <CardBody>
        <div className="d-flex align-items-center justify-content-start mb-3">
          <h5 className="mb-0 me-3">Details</h5>
          {isProfileIncomplete && (
            <div
              className="alert alert-warning d-flex align-items-center py-2 px-3 mb-0 rounded shadow-sm"
              role="alert"
              style={{
                backgroundColor: "#FFF8E5",
                borderLeft: "4px solid orange",
                color: "#703F1D",
                fontWeight: 500,
              }}
            >
              <span className="ms-2">Please complete profile for matching</span>
            </div>
          )}
        </div>

        <div
          className="d-flex  align-items-center overflow-auto"
          style={{
            width: `100%`,
            paddingTop: "10px",
            marginBottom: "10px",
            gap: "20px",
          }}
        >
          <ProfileDetailItem
            title="Location"
            data={brandLocation}
            onClick={_toggleShowAllModal}
          />
          <ProfileDetailItem
            title="Market of interest"
            data={brandMarketOfInterest}
            onClick={_toggleShowAllModal}
          />
          <ProfileDetailsMultiGenderItem
            data={brandAge}
            title="Age Group"
            brandTargetGroup={brandTarget}
            onClick={_toggleShowAllModal}
            main={mainAgePopulated}
          />
          <ProfileDetailsMultiGenderItem
            data={brandStyle}
            title="Product Style"
            brandTargetGroup={brandTarget}
            onClick={_toggleShowAllModal}
            main={mainBrandStyle}
            isAggregated={!!brand?.aggregate?.style}
          />
          {type !== "retailer" && totalLook?.length > 0 && (
            <ProfileDetailItem
              title="Total Look"
              data={totalLook}
              onClick={_toggleShowAllModal}
            />
          )}

          <ProfileDetailItem
            title="Categories"
            data={brandCategory}
            onClick={_toggleShowAllModal}
            main={mainCategory}
            isAggregated={!!brand?.aggregate?.product_category}
          />
          <ProfileDetailItem
            title="Target Group"
            data={brandTarget}
            onClick={_toggleShowAllModal}
            main={mainTargetGroup}
            isAggregated={!!brand?.aggregate?.target_group}
          />
          <ProfileDetailItem
            title="Price Range"
            data={brandPrice}
            onClick={_toggleShowAllModal}
            isAggregated={!!brand?.aggregate?.price}
          />

          {type !== "retailer" && (
            <ProfileDetailItem
              title="Price Point"
              data={brandPricePoint}
              onClick={_toggleShowAllModal}
            />
          )}

          <ProfileDetailItem
            title="Brand Rating"
            data={brandRating}
            onClick={_toggleShowAllModal}
          />
          <ProfileDetailItem
            title="Brand Rating (+2)"
            data={brandRatingUpgrade}
            onClick={_toggleShowAllModal}
          />

          {type !== "brand" && (
            <ProfileDetailItem
              title="Retailer Awareness"
              data={retailerAwarenessRating}
              onClick={_toggleShowAllModal}
            />
          )}

          {type !== "retailer" && (
            <>
              <ProfileDetailItem
                title="Eco Friendly"
                data={brandEcoFriendly}
                onClick={_toggleShowAllModal}
              />
              <ProfileDetailItem
                title="Size"
                data={brandSize}
                onClick={_toggleShowAllModal}
              />

              <ProfileDetailItem
                title="Brand Awareness"
                data={brandAwareness}
                onClick={_toggleShowAllModal}
              />

              <ProfileDetailItem
                title="Ecom Rating"
                data={ecomRating}
                onClick={_toggleShowAllModal}
              />

              <ProfileDetailItem
                title="Pos Rating"
                data={posRating}
                onClick={_toggleShowAllModal}
              />

              <ProfileDetailItem
                title="Market Diversity"
                data={marketDiversity}
                onClick={_toggleShowAllModal}
              />
            </>
          )}
        </div>
        <EditBrandModal
          open={showAllModal}
          onClose={_toggleShowAllModal}
          type={type}
        />

        <div
          className="d-flex py-2 px-3 justify-content-between align-items-center border"
          style={{
            borderRadius: "10px",
            backgroundColor: expanded ? "#000" : "#F9F9F9",
          }}
        >
          <h5 style={{ color: expanded ? "white" : "black" }}>
            Further Details
          </h5>
          <button className="btn" onClick={() => setExpanded((prev) => !prev)}>
            {expanded ? <Minus size={18} color="white" /> : <Plus size={18} />}
          </button>
        </div>

        {expanded && (
          <div
            className="d-flex py-2 px-4 justify-content-between align-items-start border mt-3 gap-3"
            style={{ borderRadius: "10px" }}
          >
            <div style={{ flex: 1 }}>
              <div className="d-flex gap-4 border-bottom py-3">
                <DocIcon />
                <h5 style={{ fontWeight: 600 }}>General Info</h5>
              </div>
              <h5
                className="border-bottom pt-4 pb-2"
                style={{ fontWeight: "bold" }}
              >
                Standard Fields{" "}
                <div
                  className="d-inline p-1 rounded"
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#76B276",
                    backgroundColor: "#e8f5e9",
                  }}
                >
                  AI Predicted
                </div>
              </h5>

              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Brand:
                </h6>
                <h6
                  style={{
                    flex: 1,
                    // display: "-webkit-box",
                    // overflow: "hidden",
                    // WebkitBoxOrient: "vertical",
                    // WebkitLineClamp: 3,
                    lineHeight: 1.4,
                  }}
                  className="flex-1"
                >
                  {brand?.name}
                </h6>
              </div>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Location:
                </h6>
                <h6
                  style={{
                    flex: 1,
                    // display: "-webkit-box",
                    // overflow: "hidden",
                    // WebkitBoxOrient: "vertical",
                    // WebkitLineClamp: 3,
                    lineHeight: 1.4,
                  }}
                  id="market"
                  className="flex-1"
                >
                  {brand?.country || "--"}
                </h6>
                <UncontrolledTooltip placement="left" target="market">
                  {brand?.country || "--"}
                </UncontrolledTooltip>
              </div>

              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Category:
                </h6>
                <h6
                  style={{
                    flex: 1,
                    // display: "-webkit-box",
                    // overflow: "hidden",
                    // WebkitBoxOrient: "vertical",
                    // WebkitLineClamp: 3,
                    lineHeight: 1.4,
                  }}
                  id="main_category"
                  className="flex-1"
                >
                  {brand?.main_category}
                </h6>
                <UncontrolledTooltip placement="left" target="main_category">
                  {brand?.main_category}
                </UncontrolledTooltip>
              </div>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Target group:
                </h6>
                <h6
                  style={{
                    flex: 1,
                    lineHeight: 1.4,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "2px", // optional if using spans inline-block
                  }}
                  id="target_group"
                  className="flex-1"
                >
                  {[...(brand?.target_group || [])]
                    .sort((a, b) => {
                      const main = brand?.main_target_group?.toLowerCase();
                      const aLower = a.toLowerCase();
                      const bLower = b.toLowerCase();
                      if (aLower === main) return -1;
                      if (bLower === main) return 1;
                      return 0;
                    })
                    .map((item, index, arr) => {
                      const isMain =
                        item?.toLowerCase() ===
                        brand?.main_target_group?.toLowerCase();
                      return (
                        <span
                          key={index}
                          style={{
                            backgroundColor: isMain ? "#fcedc0" : "#f5f5f5",
                            color: isMain ? "#e8b009" : "black",
                            borderRadius: "12px",
                            padding: "2px 10px",
                            fontWeight: isMain ? 600 : "normal",
                            marginRight: "6px", // <-- spacing between items
                            display: "inline-block", // ensures padding/margin applies cleanly
                          }}
                        >
                          {item}
                        </span>
                      );
                    })}
                </h6>

                <UncontrolledTooltip placement="left" target="target_group">
                  {[...(brand?.target_group || [])]
                    .sort((a, b) =>
                      a.toLowerCase() === "men"
                        ? -1
                        : b.toLowerCase() === "men"
                          ? 1
                          : 0
                    )
                    .join(", ")}
                </UncontrolledTooltip>
              </div>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Product Category:
                </h6>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px", // spacing between items
                  }}
                  id="product_category"
                  className="flex-1"
                >
                  {[...(brand?.product_category || [])]
                    .sort((a, b) => {
                      const main = brand?.main_category?.toLowerCase();
                      return a.toLowerCase() === main
                        ? -1
                        : b.toLowerCase() === main
                          ? 1
                          : 0;
                    })
                    .map((category, index) => {
                      const isMain =
                        category?.toLowerCase() ===
                        brand?.main_category?.toLowerCase();
                      return (
                        <span
                          key={index}
                          style={{
                            padding: "2px 10px",
                            borderRadius: "25px",
                            backgroundColor: isMain ? "#fcedc0" : "#f5f5f5",
                            color: isMain ? "#e8b009" : "#333",
                            fontWeight: isMain ? "600" : "500",
                            fontSize: "14px",
                          }}
                        >
                          {category}
                        </span>
                      );
                    })}
                </div>
                <UncontrolledTooltip placement="left" target="product_category">
                  {(brand?.product_category || []).join(", ")}
                </UncontrolledTooltip>
              </div>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Product Style:
                </h6>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px", // spacing between styles
                  }}
                  id="style"
                  className="flex-1"
                >
                  {[...(brand?.style || [])]
                    .sort((a, b) => {
                      const main = brand?.main_style?.toLowerCase();
                      return a.toLowerCase() === main
                        ? -1
                        : b.toLowerCase() === main
                          ? 1
                          : 0;
                    })
                    .map((style, index) => {
                      const isMain =
                        style?.toLowerCase() ===
                        brand?.main_style?.toLowerCase();
                      return (
                        <div
                          key={index}
                          style={{
                            padding: "2px 10px",
                            borderRadius: "25px",
                            backgroundColor: isMain ? "#fcedc0" : "#f5f5f5",
                            color: isMain ? "#e8b009" : "#333",
                            fontWeight: isMain ? "600" : "500",
                            fontSize: "14px",
                          }}
                        >
                          {style}
                        </div>
                      );
                    })}
                </div>
                <UncontrolledTooltip placement="left" target="style">
                  {(brand?.style || []).join(", ")}
                </UncontrolledTooltip>
              </div>

              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Age group:
                </h6>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px", // spacing between age groups
                  }}
                  id="age"
                  className="flex-1"
                >
                  {[...(brand?.age || [])]
                    .sort((a, b) => {
                      const main = brand?.main_age?.toLowerCase();
                      return a.toLowerCase() === main
                        ? -1
                        : b.toLowerCase() === main
                          ? 1
                          : 0;
                    })
                    .map((age, index) => {
                      const isMain =
                        age?.toLowerCase() === brand?.main_age?.toLowerCase();
                      return (
                        <div
                          key={index}
                          style={{
                            padding: "2px 10px",
                            borderRadius: "25px",
                            backgroundColor: isMain ? "#fcedc0" : "#f5f5f5",
                            color: isMain ? "#e8b009" : "#333",
                            fontWeight: isMain ? "600" : "500",
                            fontSize: "14px",
                          }}
                        >
                          {age}
                        </div>
                      );
                    })}
                </div>
                <UncontrolledTooltip placement="left" target="age">
                  {(brand?.age || []).join(", ")}
                </UncontrolledTooltip>
              </div>

              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Price Range:
                </h6>
                <h6
                  style={{
                    flex: 1,
                    // display: "-webkit-box",
                    // overflow: "hidden",
                    // WebkitBoxOrient: "vertical",
                    // WebkitLineClamp: 3,
                    lineHeight: 1.4,
                  }}
                  id="price"
                  className="flex-1"
                >
                  {brand?.price?.join(", ")}
                </h6>
                <UncontrolledTooltip placement="left" target="price">
                  {brand?.price?.join(", ")}
                </UncontrolledTooltip>
              </div>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.6 }}
                  className="flex-1"
                >
                  Price Point:
                </h6>
                <h6
                  style={{
                    flex: 1,
                    // display: "-webkit-box",
                    // overflow: "hidden",
                    // WebkitBoxOrient: "vertical",
                    // WebkitLineClamp: 3,
                    lineHeight: 1.4,
                  }}
                  id="price_point"
                  className="flex-1"
                >
                  {brand?.price_point}
                </h6>
                <UncontrolledTooltip placement="left" target="price_point">
                  {brand?.price_point}
                </UncontrolledTooltip>
              </div>

              <h5
                className="border-bottom pt-4 pb-2"
                style={{ fontWeight: "bold" }}
              >
                Addtional Properties{" "}
                <div
                  className="d-inline p-1 rounded"
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#e8b009",
                    backgroundColor: "#fcedc0",
                  }}
                >
                  User Added
                </div>
              </h5>
              {type === "retailer" && (
                <>
                  {/* <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Pitti Id:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        // display: "-webkit-box",
                        // overflow: "hidden",
                        // WebkitBoxOrient: "vertical",
                        // WebkitLineClamp: 3,
                        lineHeight: 1.4,
                      }}
                      id="pitti_id"
                      className="flex-1"
                    >
                      {brand?.pitti_id}
                    </h6>
                  </div> */}
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Type of Activity:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        // display: "-webkit-box",
                        // overflow: "hidden",
                        // WebkitBoxOrient: "vertical",
                        // WebkitLineClamp: 3,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.type_of_activity || "--"}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Signboard:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        // display: "-webkit-box",
                        // overflow: "hidden",
                        // WebkitBoxOrient: "vertical",
                        // WebkitLineClamp: 3,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.signboard || "--"}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Signboard City:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        // display: "-webkit-box",
                        // overflow: "hidden",
                        // WebkitBoxOrient: "vertical",
                        // WebkitLineClamp: 3,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.signboard_city || "--"}
                    </h6>
                  </div>
                </>
              )}
              {type === "brand" ? (
                <>
                  <h5
                    className="border-bottom pt-4 pb-2"
                    style={{ fontWeight: "bold" }}
                  >
                    Company-Specific Fields
                  </h5>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Comapny Name:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        // display: "-webkit-box",
                        // overflow: "hidden",
                        // WebkitBoxOrient: "vertical",
                        // WebkitLineClamp: 3,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.company_name || "MANUFACTURAS ANDREU, S.L."}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Comapny Webiste:
                    </h6>
                    {brand?.company_website ? (
                      <a
                        href={brand?.company_website}
                        target="_blank"
                        style={{
                          flex: 1,
                          display: "-webkit-box",
                          overflow: "hidden",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                        }}
                        className="flex-1"
                        rel="noreferrer"
                      >
                        {brand?.company_website}
                      </a>
                    ) : (
                      <h6 style={{ flex: 1 }}>--</h6>
                    )}
                  </div>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Country:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        // display: "-webkit-box",
                        // overflow: "hidden",
                        // WebkitBoxOrient: "vertical",
                        // WebkitLineClamp: 3,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.country || "--"}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Country Code:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        // display: "-webkit-box",
                        // overflow: "hidden",
                        // WebkitBoxOrient: "vertical",
                        // WebkitLineClamp: 3,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.country_code || "--"}
                    </h6>
                  </div>
                </>
              ) : (
                <>
                  <h5
                    className="border-bottom pt-4 pb-2"
                    style={{ fontWeight: "bold" }}
                  >
                    Location Details
                  </h5>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Country:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.country || "--"}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Country Code:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.country_code || "--"}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      City:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.City || "--"}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center border-bottom py-2">
                    <h6
                      style={{ fontWeight: "bold", flex: 0.6 }}
                      className="flex-1"
                    >
                      Address:
                    </h6>
                    <h6
                      style={{
                        flex: 1,
                        lineHeight: 1.4,
                      }}
                      className="flex-1"
                    >
                      {brand?.address || "--"}
                    </h6>
                  </div>
                </>
              )}
            </div>
            <div
              className="border"
              style={{ height: "700px", width: "0.5px" }}
            />
            <div style={{ flex: 1, height: "100%" }}>
              <div className="d-flex gap-4 border-bottom py-3">
                <SocialIcon />
                <h5 style={{ fontWeight: 600 }}>Social Info</h5>
              </div>
              <h5
                className="border-bottom pt-4 pb-2"
                style={{ fontWeight: "bold" }}
              >
                Links
              </h5>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.4, fontSize: "14px" }}
                  className="flex-1"
                >
                  Website:
                </h6>
                {brand?.website ? (
                  <a
                    href={brand?.website}
                    target="_blank"
                    style={{
                      flex: 1,
                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                    }}
                    className="flex-1"
                    rel="noreferrer"
                  >
                    {brand?.website}
                  </a>
                ) : (
                  <h6 style={{ flex: 1 }}>--</h6>
                )}
              </div>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.4, fontSize: "14px" }}
                  className="flex-1"
                >
                  Facebook:
                </h6>
                {brand?.facebook ? (
                  <a
                    href={brand?.facebook}
                    target="_blank"
                    style={{
                      flex: 1,
                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                    }}
                    className="flex-1"
                    rel="noreferrer"
                  >
                    {brand?.facebook}
                  </a>
                ) : (
                  <h6 style={{ flex: 1 }}>--</h6>
                )}
              </div>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.4, fontSize: "14px" }}
                  className="flex-1"
                >
                  Instagram:
                </h6>
                {brand?.instagram ? (
                  <a
                    href={brand?.instagram}
                    target="_blank"
                    style={{
                      flex: 1,
                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                    }}
                    className="flex-1"
                    rel="noreferrer"
                  >
                    {brand?.instagram}
                  </a>
                ) : (
                  <h6 style={{ flex: 1 }}>--</h6>
                )}
              </div>
              <div className="d-flex align-items-center border-bottom py-2">
                <h6
                  style={{ fontWeight: "bold", flex: 0.4, fontSize: "14px" }}
                  className="flex-1"
                >
                  LinkedIn:
                </h6>
                {brand?.linkedin ? (
                  <a
                    href={brand?.linkedin}
                    target="_blank"
                    style={{
                      flex: 1,
                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                    }}
                    className="flex-1"
                    rel="noreferrer"
                  >
                    {brand?.linkedin}
                  </a>
                ) : (
                  <h6 style={{ flex: 1 }}>--</h6>
                )}
              </div>
            </div>
            {type === "retailer" && (
              <>
                <div
                  className="border"
                  style={{ height: "700px", width: "0.5px" }}
                />
                <div style={{ flex: 1, height: "100%" }}>
                  <div className="d-flex gap-4 border-bottom py-3">
                    <AgentIcon />
                    <h5 style={{ fontWeight: 600 }}>Agent Info</h5>
                  </div>

                  {brand?.agent?.map((agent, index) => (
                    <div key={agent?.id} className="mb-3 border-bottom">
                      <h5
                        className="border-bottom pt-4 pb-2"
                        style={{ fontWeight: "bold" }}
                      >
                        Contact {index + 1}
                      </h5>

                      <div className="d-flex flex-wrap gap-2 py-3 border-bottom">
                        <div style={{ flexBasis: "30%" }}>
                          <h6 style={{ fontWeight: "bold" }} className="flex-1">
                            First Name:
                          </h6>
                          <p style={{ fontSize: "13px" }}>
                            {agent?.first_name}
                          </p>
                        </div>
                        <div style={{ flexBasis: "30%" }}>
                          <h6 style={{ fontWeight: "bold" }} className="flex-1">
                            Last Name:
                          </h6>
                          <p style={{ fontSize: "13px" }}>{agent?.last_name}</p>
                        </div>
                        <div style={{ flexBasis: "30%" }}>
                          <h6 style={{ fontWeight: "bold" }} className="flex-1">
                            Email:
                          </h6>
                          <div className="d-flex gap-2 align-items-center">
                            <p style={{ fontSize: "13px" }} className="mb-0">
                              {agent?.email || "--"}
                            </p>
                            <button className="btn p-0">
                              <Copy size={13} color="#999" />
                            </button>
                          </div>
                        </div>
                        {/* <div style={{ flexBasis: '30%' }}>
                      <h6 style={{ fontWeight: 'bold' }} className='flex-1'>Telephone:</h6>
                      <p style={{ fontSize: '13px' }}>{0000-00-000}</p>
                    </div>
                    <div style={{ flexBasis: '30%' }}>
                      <h6 style={{ fontWeight: 'bold' }} className='flex-1'>Phone:</h6>
                      <p style={{ fontSize: '13px' }}>000-00-000</p>
                    </div> */}
                      </div>

                      <h5
                        className="border-bottom pt-2 pb-2"
                        style={{ fontWeight: "bold" }}
                      >
                        Social Persons
                      </h5>

                      <div className="d-flex align-items-center border-bottom py-2">
                        <h6
                          style={{
                            fontWeight: "bold",
                            flex: 0.4,
                            fontSize: "14px",
                          }}
                          className="flex-1"
                        >
                          Instagram:
                        </h6>
                        {agent?.instagram ? (
                          <a
                            href={agent?.instagram}
                            target="_blank"
                            style={{
                              flex: 1,
                              display: "-webkit-box",
                              overflow: "hidden",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                            }}
                            className="flex-1"
                            rel="noreferrer"
                          >
                            {agent?.instagram}
                          </a>
                        ) : (
                          <h6 style={{ flex: 1 }}>--</h6>
                        )}
                      </div>
                      <div className="d-flex align-items-center border-bottom py-2">
                        <h6
                          style={{
                            fontWeight: "bold",
                            flex: 0.4,
                            fontSize: "14px",
                          }}
                          className="flex-1"
                        >
                          Facebook:
                        </h6>
                        {agent?.facebook ? (
                          <a
                            href={agent?.facebook}
                            target="_blank"
                            style={{
                              flex: 1,
                              display: "-webkit-box",
                              overflow: "hidden",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                            }}
                            className="flex-1"
                            rel="noreferrer"
                          >
                            {agent?.facebook}
                          </a>
                        ) : (
                          <h6 style={{ flex: 1 }}>--</h6>
                        )}
                      </div>
                      <div className="d-flex align-items-center border-bottom py-2">
                        <h6
                          style={{
                            fontWeight: "bold",
                            flex: 0.4,
                            fontSize: "14px",
                          }}
                          className="flex-1"
                        >
                          LinkedIn:
                        </h6>
                        {agent?.linkedin ? (
                          <a
                            href={agent?.linkedin}
                            target="_blank"
                            style={{
                              flex: 1,
                              display: "-webkit-box",
                              overflow: "hidden",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                            }}
                            className="flex-1"
                            rel="noreferrer"
                          >
                            {agent?.linkedin}
                          </a>
                        ) : (
                          <h6 style={{ flex: 1 }}>--</h6>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </CardBody>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  brand: state.brands.selectedBrand,
});

export default connect(mapStateToProps)(ProfileDetailsSection);
